export const LOAD_DATA = 'at/workSchedule/LOAD_DATA'
export const LOAD_DATA_SUCCESS = 'at/workSchedule/LOAD_DATA_SUCCESS'
export const LOAD_DATA_FAILURE = 'at/workSchedule/LOAD_DATA_FAILURE'
export const LOADED_DATA_SET = 'at/workSchedule/LOADED_DATA_SET'
export const EDITING_DAYS_ADD = 'at/workSchedule/EDITING_DAYS_ADD'
export const EDITING_DAYS_REMOVE = 'at/workSchedule/EDITING_DAYS_REMOVE'
export const YEAR_SELECTED = 'at/workSchedule/YEAR_SELECTED'
export const CORPORATE_DAYS_SET = 'at/workSchedule/CORPORATE_DAYS_SET'
export const DEFAULT_WORK_SCHEDULES_SET = 'at/workSchedule/DEFAULT_WORK_SCHEDULES_SET'
export const CORPORATE_DAYS_REMOVE_BY_YEAR = 'at/workSchedule/CORPORATE_DAYS_REMOVE_BY_YEAR'

export const CURRENT_COUNTRY_SET = 'at/workSchedule/CURRENT_COUNTRY_SET'

export const LOAD_COUNTRIES = 'at/workSchedule/LOAD_COUNTRIES'
export const LOAD_COUNTRIES_SUCCESS = 'at/workSchedule/LOAD_COUNTRIES_SUCCESS'
export const LOAD_COUNTRIES_FAILURE = 'at/workSchedule/LOAD_COUNTRIES_FAILURE'



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/actionTypes.js